import { LazyMotion } from 'motion/react';
import { type ReactNode } from 'react';

const LazyMotionProvider = ({ children }: { children: ReactNode }) => {
  const loadFeatures = () => import('./features').then((res) => res.domMax);
  return (
    <LazyMotion features={loadFeatures} strict>
      {children}
    </LazyMotion>
  );
};

export { LazyMotionProvider };
